<template>
  <div v-if="device===null" class="noDeviceSelected"><span>No device has been selected</span></div>
  <div v-else class="deviceOptions"></div>
</template>

<script>
  import Device from '../../../../Class/Device.js'

  export default {
    name: "device-options",
    props: {
      device: {
        type: Device,
        default() {
          return null
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .noDeviceSelected {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

  }

  .deviceOptions {

  }

</style>



// WEBPACK FOOTER //
// src/views/project/create-project/device-options/deviceOptions.vue